import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';

import useActiveProduct from '../../../../hooks/product/useActiveProduct';
import { modelOf } from '../../../../prop-types';
import AnalyticsService from '../../../../services/AnalyticsService';
import CheckoutStore from '../../../../store/CheckoutStore';
import CheckoutCartModalContent from '../CheckoutCartModalContent';

const CheckoutCartModal = ({ analyticsService, checkoutStore }) => {
  const { setActiveProductId } = useActiveProduct({
    productPage: false,
    checkoutPage: true,
  });

  useEffect(() => {
    analyticsService.viewItemCheckout();

    return () => {
      setActiveProductId({ activeProductId: null, queryParams: {} });
      checkoutStore.checkoutCartModal.close();
    };
  }, []);

  const toggleModal = () => checkoutStore.checkoutCartModal.toggle(true, false);

  return (
    <Modal
      isOpen={checkoutStore.checkoutCartModal.isOpen}
      toggle={toggleModal}
      modalClassName="CheckoutCartModal"
    >
      <ModalHeader toggle={toggleModal} />
      <ModalBody>
        <CheckoutCartModalContent />
      </ModalBody>
    </Modal>
  );
};

CheckoutCartModal.propTypes = {
  analyticsService: PropTypes.instanceOf(AnalyticsService).isRequired,
  checkoutStore: modelOf(CheckoutStore).isRequired,
};

export default inject(
  'analyticsService',
  'checkoutStore'
)(observer(CheckoutCartModal));
